import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function CreateDocument() {
  const { modals } = useFileManagerContext();

  return (
    <span className="create-document-button pointer" onClick={() => modals.setShowCreateDocumentModal(true)}>
      <Tooltip content="Create Document" position="top" target=".create-document-button" showDelay={500} />
      <i className="icon-doc fa-lg"></i>
    </span>
  );
}

export default CreateDocument;
